module.exports = __webpack_public_path__ + "static/img/Scott-Pendlebury.e7f4571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott-Pendlebury.jpg
// module id = rfO8
// module chunks = 0